import SwitchButton from '../switch-button-field/SwitchButton';

interface CustomInputSwitchInterface {
  readonly inputLabel?: string;
  readonly value?: boolean;
  readonly name: string;
  readonly onChangeValue: (name: string, value: boolean) => void;
  fontSize?: 'small' | 'medium' | 'large';
}

/**
 * Custom input select box component
 * @param param0
 * @returns
 */
function CustomInputSwitch({
  inputLabel,
  value,
  name,
  onChangeValue,
  fontSize,
}: CustomInputSwitchInterface) {
  return (
    <div className={`custom-input-switch-button-wrap ${fontSize}`}>
      <div className="switch-size">
        <SwitchButton
          checked={value}
          change={() => onChangeValue(name, !value)}
          fontSize={fontSize}
        />
      </div>
      {inputLabel && (
        <p className="input-label" role="presentation" onClick={() => onChangeValue(name, !value)}>
          {inputLabel}
        </p>
      )}
    </div>
  );
}

CustomInputSwitch.defaultProps = {
  inputLabel: '',
  value: false,
  fontSize: 'large',
};

export default CustomInputSwitch;
